import React, { useState } from 'react';
import { showToast, getData } from '../../globalFunction';
import '../createPassword/index.scss';

export type ForgotPasswordProps = {
  type: string;
  onClose?: () => void;
  height?: string;
};

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ type, onClose, height }) => {
  const [email, setEmail] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string>('');

  const validateEmail = (email: string) => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setMessage('');
    setError('');
  };

  const handleClose = () => {
    if (onClose) onClose();
    setEmail('');
    setDisabled(false);
    setMessage('');
    setError('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError('Invalid Email Address. Please Try again.');
      showToast('error', 'Invalid Email Address. Please Try again.');
      return;
    }
    setDisabled(true);
    getData(`auth/forgotPassword?email=${encodeURIComponent(email)}&type=${type}`, {}, (c: any) => {
      if (c.data && c.status === 200) {
        setMessage('success');
      } else {
        setMessage('failed');
      }
      setDisabled(false);
    });
  };

  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-[rgba(0,0,0,0.35)] tw-z-[10000] tw-font-brandon">
      <div
        className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-w-full tw-max-w-md tw-relative"
        style={{
          minWidth: '500px',
          height: height ?? '400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div className="tw-border-t tw-h-4 tw-bg-gradient-to-r tw-from-[#3CBDEB] tw-to-[#5081FF] tw-rounded-t-xl"></div>
        <div
          className="tw-flex-1 tw-flex tw-flex-col tw-justify-center tw-self-center tw-px-16"
          style={{ maxWidth: 500, justifySelf: 'center' }}
        >
          <div className="tw-absolute tw-top-6 tw-right-6">
            <button
              type="button"
              onClick={handleClose}
              aria-label="Close"
              className="tw-text-black tw-text-right"
            >
              <span className="tw-cursor-pointer">
                <i className="material-icons">close</i>
              </span>
            </button>
          </div>
          <div className="tw-text-center tw-mb-4">
            <h2 className="tw-text-xl tw-font-semibold tw-font-brandon-bold tw-mb-4">
              Forgot your Password?
            </h2>
            <p className="tw-text-center tw-text-base tw-mb-4">
              Don’t worry, we’ll send a reset password link to your email!
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="tw-mb-4">
              <label
                htmlFor="project-type"
                className="tw-block tw-font-medium tw-text-base tw-mb-4"
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                required
                value={email}
                className="tw-form-control tw-w-full tw-py-2 tw-px-3 tw-text-base tw-rounded tw-border tw-border-gray-300 focus:tw-outline-none focus:tw-border-blue-400 tw-mb-4"
                placeholder="jdoe@xyztrading.ph"
                onChange={handleChange}
              />
            </div>
            {error && (
              <div className="tw-mb-2 tw-text-red-600 tw-text-sm">
                <p className="tw-m-0">{error}</p>
              </div>
            )}
            <div className="tw-mb-4">
              <button
                type="submit"
                className={`tw-btn tw-w-full tw-py-3 tw-text-base tw-rounded tw-bg-blue-500 tw-text-white tw-font-semibold ${email === '' ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}`}
                disabled={disabled || email === ''}
              >
                {disabled
                  ? 'Sending ...'
                  : message === 'failed'
                    ? 'Send Link'
                    : message
                      ? 'Re-send Link'
                      : 'Send Link'}
              </button>
            </div>
          </form>
          {message && (
            <div className="tw-mt-2 tw-text-center tw-text-base">
              {message === 'failed' && (
                <p className="tw-m-0">
                  Your email, <span className="tw-font-bold">{email}</span>, does not exist.
                  <br />
                  Please type another email.
                </p>
              )}
              {message === 'success' && (
                <p className="tw-m-0">
                  A reset password link has been sent to{' '}
                  <span className="tw-font-bold">{email}</span>
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
